import { createAsyncThunk } from '@reduxjs/toolkit'
import CategoryValue from './category-value-model'
import {
  delete_categoryValue,
  load_categoryValues,
  store_categoryValue,
} from './categoryValue-service'

export const LoadCategoryValuesAsync = createAsyncThunk<any, any>(
  'composer/load/categoryValue',
  async (params: { uid: string }) => {
    return await load_categoryValues(params)
  },
)

export const CreateCategoryValueAsync = createAsyncThunk<any, any>(
  'composer/create/categoryValue',
  async (params: CategoryValue) => {
    return await store_categoryValue(params)
  },
)

export const DeleteCategoryValueAsync = createAsyncThunk<any, any>(
  'composer/delete/categoryValue',
  async (params) => {
    return await delete_categoryValue(params)
  },
)
